/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';
import { getUpMedia } from '../../styles';
import { useModals } from '../../providers';
import { TabletDownBr, TabletUpBr } from '../../styled';
import { Text } from '../alert-modals/Text.tsx';
import { Title } from '../alert-modals/Title.tsx';
import { Button as DefButton } from '../buttons';

const NewRebalanceModal = () => {
  const { t } = useTranslation();
  const { data, dispatch } = useModals<'expectedPortfolio'>();

  const onClick = () => {
    dispatch({
      type: 'setModalContent',
      payload: {
        name: 'expectedPortfolio',
        data: {
          exchangeId: data!.exchangeId,
          exchangeCode: data!.exchangeCode,
        },
        prepend: true,
      },
    });
    dispatch({
      type: 'closeModal',
    });
  };

  return (
    <>
      <Title>
        <Trans
          i18nKey="NEW_REBALANCE_MODAL__title"
          components={{ 1: <TabletDownBr /> }}
        />
      </Title>
      <Text>
        <Trans
          i18nKey="NEW_REBALANCE_MODAL__desc"
          components={{ 1: <TabletUpBr /> }}
        />
      </Text>
      <Button onClick={onClick}>{t('NEW_REBALANCE_MODAL__button')}</Button>
    </>
  );
};

const deskOffset = 30 as const;
const Button = styled(DefButton)`
  width: 100%;
  margin-top: 20px;
  ${getUpMedia('md')} {
    width: calc(100% - ${deskOffset * 2}px);
    margin-left: ${deskOffset}px;
    margin-right: ${deskOffset}px;
  }
`;

export type NewRebalanceModalData = {
  exchangeId: number;
  exchangeCode: string;
};

export { NewRebalanceModal };
